module.exports = __webpack_public_path__ + "static/rainbow-square-b6ccdf5fd5bce7ffbb3a1c32cf5f98fa.jpg";